<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" @page:init="onPageInit">
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("home_0175") }}</f7-nav-title>
    </f7-navbar>
    <!--  muted-->
    <div class="profit">
      <div v-if="HomePageRulesRemark" v-html="HomePageRulesRemark"></div>
      <div v-else class="qidai">
        <div class="ablock">
          <img src="../static/images/yt999/qidai.png" alt="" width="70%">
          <div>{{$t('bonusv1_04')}}</div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>

import { getStore } from "@/config/utils";
import { getwebsiteinfoGet } from "../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      HomePageRulesRemark: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onPageInit() {
      const self = this;
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          self.HomePageRulesRemark= data.Data.HomePageRulesRemark;
        }
      });

    },

  },
  created() { 
    
    
  },
  mounted() { 
    
  },
};
</script>

<style lang="less" >
  .profit{
    p{
      margin: 0;
    }
    .qidai{
      // background: var(--f7-THEME-color);
      text-align: center;
      // padding: 10px;
      // height: 100vh;
      div{
        font-size: 18px;
      }
      .ablock{
        background: #fff;
        min-height: 80vh;
        border-radius: 10px;
        // padding-top: 50px;
      }
    }
  }
</style>